import React from 'react';

const SNIntro = () => {
    return(
        <div>
            <p className="p2">
                <b>{`Social Native`}</b> {`is a technology company reinventing how brands conceptualize and create content. Our content engine connects brands with a diverse group of epic content creators, globally, to create high-performing, cost effective branded content on demand. Social Native partners with some of the most influential brands in the world including Polaroid, Walgreens, and General Motors. Founded by veterans of Salesforce, Google, Scopely, and Applied Semantics whose past startups have created over $6B in equity value, we're building another industry transforming company. We're off to a fantastic start, and we're looking for A+ players to help take us to the next level.`}
            </p>
            <br/>
        </div>
    );
};

export default SNIntro;


// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/components/sn_intro.js